export default {
  name: "add_row",
  box: 24,
  svg: `<path d="M12 12H4M12 20V12V20ZM12 12V4V12ZM12 12H20H12Z" stroke="white" stroke-width="2" stroke-linecap="round"/>`,
};
